import React, { ReactNode } from "react";
import type { FeatureFlag } from "./featureFlags";
import { useFeatureFlags } from "./useFeatureFlags";

type SingleFlagProps = {
  flags: FeatureFlag;
  children: ReactNode;
  fallback?: ReactNode;
};

type MultiFlagProps = {
  flags: FeatureFlag[];
  condition?: "all" | "any";
  children: ReactNode;
  fallback?: ReactNode;
};

type FeatureToggleProps = SingleFlagProps | MultiFlagProps;

export const FeatureToggle = (props: FeatureToggleProps) => {
  const { flags, children, fallback = null } = props;
  const { isFeatureEnabled } = useFeatureFlags();

  if (Array.isArray(flags)) {
    const { condition = "all" } = props as MultiFlagProps;

    const isEnabled =
      condition === "any"
        ? flags.some((flag) => isFeatureEnabled(flag))
        : flags.every((flag) => isFeatureEnabled(flag));

    return <>{isEnabled ? children : fallback}</>;
  }

  return <>{isFeatureEnabled(flags) ? children : fallback}</>;
};
